import React from 'react';
import {
  Link
} from "@mui/material";

interface Props { 
  onChange: (letter: string) => void;
}

export default function LetterLinks({ 
  onChange,
}: Props) {
  const alphabet = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","Clear"];
  return (
    <div>
      { alphabet.map((a, key) => {
        return (
          <div key={key} style={{ float: "left", margin: "4px" }}>
            <Link href="#" 
              onClick={(event: React.SyntheticEvent) => {
                event.preventDefault();
                onChange(a === "Clear" ? "" : a);
              }}>
              {a}
            </Link>
          </div>
        );
      })}
    </div>
  );
}
